import { i18n } from "@lib/i18n";
import { rootRoute } from "@routes";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const activateAccountRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: `invitation`,
    beforeLoad: () => ({ getTitle: () => i18n.activate_account_title() }),
    component: lazyRouteComponent(() => import("./ActivateAccount")),
});
